// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation.json"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1300 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const menu = {
  en: {
    skills: "Skills",
    workExperience: "Work Experience",
    achievements: "Achievements",
    resume: "Resume",
    contact: "Contact me"
  },
  de: {
    skills: "Skills",
    workExperience: "Berufserfahrung",
    achievements: "Erfolg",
    resume: "Lebenslauf",
    contact: "Kontaktiere mich"
  }
};

const greeting = {
  en: {
    username: "Camilo Fernandez",
    title: "Hi all, I'm Camilo",
    subTitle: emoji(
      "I'm a DevOps and cloud engineer who loves building cloud-native solutions, blending Go, Kubernetes, and " +
        "Databricks APIs to power AI-driven platforms 🚀. Whether it's helping companies scale in the cloud 🌐, boosting " +
        "agritech innovations 🌿, or tackling cool projects in gaming, I’m all about turning complex challenges into smooth, high-performance systems ⚙️💡."
    ),
    resumeLink:
      "https://drive.google.com/file/d/1EG2TsWvuRA9ErGHncUjjgQsOxf1oJSq4/view?usp=sharing"
  },
  de: {
    username: "Camilo Fernandez",
    title: "Hi all, I'm Camilo",
    subTitle: emoji(
      "Ich bin ein DevOps- und Cloud-Engineer, der leidenschaftlich gerne cloud-native Lösungen entwickelt – mit Go, Kubernetes und " +
        "Databricks APIs, um KI-gesteuerte Plattformen anzutreiben 🚀. Ob beim Skalieren von Unternehmen in der Cloud 🌐, beim Vorantreiben " +
        "von Innovationen in der Agrartechnologie 🌿 oder bei spannenden Projekten im Gaming-Bereich – ich liebe es, komplexe Herausforderungen " +
        "in reibungslose, leistungsstarke Systeme zu verwandeln ⚙️💡."
    ),
    resumeLink:
      "https://drive.google.com/file/d/1SBAnvzhA_OZjNsY_e1NIJsioh5OHlvta/view?usp=sharing" // Set to empty to hide the button
  },
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  //github: "https://github.com/saadpasta",
  linkedin: "https://www.linkedin.com/in/camilo-fernandez-ai/",
  gmail: "fernandez.camilo@live.com",
  upwork: "https://www.upwork.com/freelancers/~01b3891afb07def9e9?viewMode=1",
  //gitlab: "https://gitlab.com/saadpasta",
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  en: {
    title: "What I do",
    subTitle: "CLOUD-NATIVE DEVOPS ENGINEER BUILDING AI-DRIVEN SOLUTIONS",
    skills: [
      emoji(
        "⚙️ Build scalable backend services and infrastructure with Go, Kubernetes, and Databricks APIs"
      ),
      emoji(
        "🌐 Develop and deploy cloud-native platforms on Azure, AWS, and on-prem solutions"
      ),
      emoji(
        "🤖 Implement AI-driven systems, including Retrieval-Augmented Generation (RAG) pipelines"
      ),
      emoji(
        "🔗 Integrate third-party services and APIs to streamline workflows and data pipelines"
      ),
      emoji("🚀 Optimize CI/CD pipelines for efficient, reliable deployments")
    ]
  },
  de: {
    title: "Was ich mache",
    subTitle:
      "CLOUD-NATIVE DEVOPS ENGINEER, DER KI-GESTEUERTE LÖSUNGEN ENTWICKELT",
    skills: [
      emoji(
        "⚙️ Skalierbare Backend-Dienste und Infrastrukturen mit Go, Kubernetes und Databricks APIs erstellen"
      ),
      emoji(
        "🌐 Entwicklung und Bereitstellung cloud-nativer Plattformen auf Azure, AWS und lokalen Systemen"
      ),
      emoji(
        "🤖 Implementierung KI-gesteuerter Systeme, einschließlich RAG-Pipelines (Retrieval-Augmented Generation)"
      ),
      emoji(
        "🔗 Integration von Drittanbieter-Services und APIs zur Optimierung von Workflows und Datenpipelines"
      ),
      emoji(
        "🚀 Optimierung von CI/CD-Pipelines für effiziente und zuverlässige Deployments"
      )
    ]
  },
  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Qdrant",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  en: {
    title: "Top Skills",
    experience: [
      {Stack: "Cloud & DevOps", progressPercentage: "90%"},
      {Stack: "AI, RAG & Data Solutions", progressPercentage: "85%"},
      {Stack: "Scalable APIs & Microservices", progressPercentage: "75%"}
    ]
  },
  de: {
    title: "Top-Fähigkeiten",
    experience: [
      {Stack: "Cloud & DevOps", progressPercentage: "90%"},
      {Stack: "KI, RAG & Datenlösungen", progressPercentage: "85%"},
      {Stack: "Skalierbare APIs & Microservices", progressPercentage: "75%"}
    ]
  },
  viewSkillBars: true,
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  en: {
    title: "Work Experience",
    experience: [
      {
        role: "Fullstack Developer",
        company: "EELOY AG",
        companylogo: require("./assets/images/eeloyLogo.png"),
        date: "Jan 2015 – Sep 2015",
        desc: "Focused on backend development with marketing automation, database management, and reactive frontends",
        descBullets: [
          "Developed backend services for marketing automation workflows",
          "Managed SQL databases for campaign analytics and reporting",
          "Built user interfaces with React for internal dashboards",
          "Increased data quality with ETL automation for vast amounts of customer data using Python and Pandas"
        ]
      },
      {
        role: "DevOps Engineer",
        company: "Agribora GmbH",
        companylogo: require("./assets/images/agribora.jpg"),
        date: "April 2021 – April 2022",
        desc: "Led cloud and DevOps initiatives for agritech solutions, enhancing system efficiency and reliability.",
        descBullets: [
          "Built Managed infrastructure as code (IaC) using Terraform and Kubernetes on AWS",
          "Migration of Microservices and distributed systems to the cloud",
          "Promoted DevOps culture and education across organization"
        ]
      },
      {
        role: "Cloud Infrastructure Engineer",
        company: "Mercedes-Benz Mobility AG",
        companylogo: require("./assets/images/mercedesStar.png"),
        date: "April 2022 – Present",
        desc: "Driving cloud infrastructure projects with a focus on scalability, automation, and reliability.",
        descBullets: [
          "Built and managed Kubernetes-based infrastructure on Azure",
          "Optimized GitOps pipelines for faster and more reliable deployments using FluxCD",
          "Implemented complete monitoring and alerting with Datadog"
        ]
      }
    ]
  },
  de: {
    title: "Berufserfahrung",
    experience: [
      {
        role: "Fullstack-Entwickler",
        company: "EELOY AG",
        companylogo: require("./assets/images/eeloyLogo.png"),
        date: "Jan 2015 – Sep 2015",
        desc: "Fokus auf Backend-Entwicklung mit Marketingautomatisierung, Datenbankverwaltung und reaktiven Frontends.",
        descBullets: [
          "Entwicklung von Backend-Diensten für Marketing-Automatisierungs-Workflows",
          "Verwaltung von SQL-Datenbanken für Kampagnenanalyse und Berichterstattung",
          "Erstellung von Benutzeroberflächen mit React für interne Dashboards",
          "Erhöhung der Datenqualität mit ETL-Automatisierung für große Datenmengen"
        ]
      },
      {
        role: "DevOps-Ingenieur",
        company: "Agribora GmbH",
        companylogo: require("./assets/images/agribora.jpg"),
        date: "April 2021 – April 2022",
        desc: "Leitung von Cloud- und DevOps-Initiativen für Agritech-Lösungen zur Verbesserung von Effizienz und Zuverlässigkeit.",
        descBullets: [
          "Erstellung und Verwaltung von Infrastruktur mit Terraform und Kubernetes auf AWS",
          "Migration von Microservices und verteilten Systemen in die Cloud",
          "Förderung der DevOps-Kultur im gesamten Unternehmen"
        ]
      },
      {
        role: "Cloud-Infrastruktur-Ingenieur",
        company: "Mercedes-Benz Mobility AG",
        companylogo: require("./assets/images/mercedesStar.png"),
        date: "April 2022 – Heute",
        desc: "Leitung von Cloud-Infrastrukturprojekten mit Fokus auf Skalierbarkeit, Automatisierung und Zuverlässigkeit.",
        descBullets: [
          "Aufbau und Verwaltung Kubernetes-basierter Infrastruktur auf Azure",
          "Optimierung von GitOps-Pipelines für schnellere und zuverlässigere Deployments mit FluxCD",
          "Implementierung von vollständigem Monitoring und Alerting mit Datadog"
        ]
      }
    ]
  },
  display: true
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  en: {
    title: "Big Projects",
    subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
    projects: [
      {
        image: require("./assets/images/eeloyLogo.png"),
        projectName:
          "Data-Driven Marketing Automation for Mercedes-Benz Vehicle Tires",
        projectDesc:
          "Faced with diverse and inconsistent data sources, I enhanced robust backend services " +
          "to support detailed campaign analytics and reporting. I also developed efficient ETL pipelines to " +
          "standardize and cleanse vast amounts of data, including critical vehicle tire information. This project laid a strong" +
          " foundation for a more reliable, data-driven marketing process, significantly boosting operational effectiveness" +
          " for Mercedes Benz car dealers across Germany.",
        footerLink: [
          {
            name: "eeloy.com",
            url: "https://eeloy.com/"
          }
        ]
      },
      {
        image: require("./assets/images/agribora.jpg"),
        projectName:
          "Revolutionizing Microservices: Docker to AWS Cloud Transformation",
        projectDesc:
          "Migrated a suite of microservices from Docker Compose to AWS EKS, unlocking enhanced scalability and resilience." +
          " Leveraging Terraform for seamless infrastructure automation and Kubernetes for robust orchestration, " +
          "this project streamlined deployments and optimized system performance for a truly cloud-native experience.",
        footerLink: [
          {
            name: "agribora.com",
            url: "https://agribora.com/"
          }
        ]
      },
      {
        image: require("./assets/images/mercedesStar.png"),
        projectName:
          "Mercedes-Benz Mobility AG: Next-Generation Cloud Transformation",
        projectDesc:
          "Revolutionized a legacy system by migrating over tens of microservices into a cutting-edge GitOps " +
          "environment on GitHub using FluxCD. This transformative " +
          "project dramatically slashed costs while turbocharging availability and scalability. By harnessing automated " +
          "deployments and modern container orchestration, service reliability was significantly enhanced with minimal downtime. " +
          "The integration of GitOps best practices enabled seamless updates and continuous delivery, setting a new benchmark for operational efficiency.",
        footerLink: [
          {
            name: "mercedes-benz-mobility.com",
            url: "https://www.mercedes-benz-mobility.com/de/"
          }
        ]
      }
    ]
  },
  de: {
    title: "Big Projects",
    subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
    projects: [
      {
        image: require("./assets/images/eeloyLogo.png"),
        projectName:
          "Data-Driven Marketing Automation for Mercedes-Benz Vehicle Tires",
        projectDesc:
          "Faced with diverse and inconsistent data sources, I enhanced robust backend services " +
          "to support detailed campaign analytics and reporting. I also developed efficient ETL pipelines to " +
          "standardize and cleanse vast amounts of data, including critical vehicle tire information. This project laid a strong" +
          " foundation for a more reliable, data-driven marketing process, significantly boosting operational effectiveness" +
          " for Mercedes Benz car dealers across Germany.",
        footerLink: [
          {
            name: "eeloy.com",
            url: "https://eeloy.com/"
          }
        ]
      },
      {
        image: require("./assets/images/agribora.jpg"),
        projectName:
          "Revolutionizing Microservices: Docker to AWS Cloud Transformation",
        projectDesc:
          "Migrated a suite of microservices from Docker Compose to AWS EKS, unlocking enhanced scalability and resilience." +
          " Leveraging Terraform for seamless infrastructure automation and Kubernetes for robust orchestration, " +
          "this project streamlined deployments and optimized system performance for a truly cloud-native experience.",
        footerLink: [
          {
            name: "agribora.com",
            url: "https://agribora.com/"
          }
        ]
      },
      {
        image: require("./assets/images/mercedesStar.png"),
        projectName:
          "Mercedes-Benz Mobility AG: Next-Generation Cloud Transformation",
        projectDesc:
          "Revolutionized a legacy system by migrating over tens of microservices into a cutting-edge GitOps " +
          "environment on GitHub using FluxCD. This transformative " +
          "project dramatically slashed costs while turbocharging availability and scalability. By harnessing automated " +
          "deployments and modern container orchestration, service reliability was significantly enhanced with minimal downtime. " +
          "The integration of GitOps best practices enabled seamless updates and continuous delivery, setting a new benchmark for operational efficiency.",
        footerLink: [
          {
            name: "mercedes-benz-mobility.com",
            url: "https://www.mercedes-benz-mobility.com/de/"
          }
        ]
      }
    ]
  },
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  en: {
    title: emoji("Certifications 🏆 "),
    subtitle: "Certifications and courses that I have completed",
    achievementsCards: [
      {
        title: "Machine Learning",
        subtitle:
          "Solid foundation on Machine learning algorithms and their applications.",
        image: require("./assets/images/courseraMLCert.png"),
        imageAlt: "Coursera ML",
        footerLink: [
          {
            name: "Certification",
            url: "https://coursera.org/share/be30e255eb70c5adf02f23e7ff6ed549"
          }
        ]
      },
      {
        title: "Object-Oriented Data Structures in C++",
        subtitle: "Architecting software for performant and scalable systems.",
        image: require("./assets/images/courseraCppCert.png"),
        imageAlt: "OOP in CPP",
        footerLink: [
          {
            name: "Certification",
            url: "https://coursera.org/share/f0ce8f7e9f2a0b01d0ae5517ad898922"
          }
        ]
      },
      {
        title: "Neural Networks and Deep Learning",
        subtitle: "Complex algorithms for solving industry problems.",
        image: require("./assets/images/courseraDLCert.png"),
        imageAlt: "NN and DL",
        footerLink: [
          {
            name: "Certification",
            url: "https://coursera.org/share/2730991c2195b13043bd353d0564ed1b"
          }
        ]
      },
      {
        title: "Azure",
        subtitle:
          "Building the foundation for cloud computing with Azure services",
        image: require("./assets/images/azureFoundCert.png"),
        imageAlt: "Azure",
        footerLink: [
          {
            name: "Certification",
            url: "https://learn.microsoft.com/api/credentials/share/en-us/CamiloFernandez-1173/9196E33AA29DF002?sharingId=C761A39A14C07EDA"
          }
        ]
      }
    ]
  },
  de: {
    title: emoji("Zertifikate 🏆 "),
    subtitle: "Zertifizierungen und Kurse, die ich abgeschlossen habe",
    achievementsCards: [
      {
        title: "Maschinelles Lernen",
        subtitle: "Solide Grundlagen in ML-Algorithmen und deren Anwendungen.",
        image: require("./assets/images/courseraMLCert.png"),
        imageAlt: "Coursera ML",
        footerLink: [
          {
            name: "Zertifikat",
            url: "https://coursera.org/share/be30e255eb70c5adf02f23e7ff6ed549"
          }
        ]
      },
      {
        title: "Objektorientierte Datenstrukturen in C++",
        subtitle:
          "Softwarearchitektur für leistungsstarke und skalierbare Systeme.",
        image: require("./assets/images/courseraCppCert.png"),
        imageAlt: "OOP in CPP",
        footerLink: [
          {
            name: "Zertifikat",
            url: "https://coursera.org/share/f0ce8f7e9f2a0b01d0ae5517ad898922"
          }
        ]
      },
      {
        title: "Neuronale Netzwerke und Deep Learning",
        subtitle: "Komplexe Algorithmen zur Lösung industrieller Probleme.",
        image: require("./assets/images/courseraDLCert.png"),
        imageAlt: "NN und DL",
        footerLink: [
          {
            name: "Zertifikat",
            url: "https://coursera.org/share/2730991c2195b13043bd353d0564ed1b"
          }
        ]
      },
      {
        title: "Azure",
        subtitle: "Grundlagen der Cloud-Technologien mit Azure-Diensten",
        image: require("./assets/images/azureFoundCert.png"),
        imageAlt: "Azure",
        footerLink: [
          {
            name: "Zertifikat",
            url: "https://learn.microsoft.com/api/credentials/share/en-us/CamiloFernandez-1173/9196E33AA29DF002?sharingId=C761A39A14C07EDA"
          }
        ]
      }
    ]
  },
  display: true
};

// Blogs Section

const blogPosts = [
  {
    slug: "devops-portfolio-infra",
    title: "From Template to Infrastructure: My Portfolio Journey",
    content:
      "When I first stumbled upon a beautiful React portfolio template, I saw more than just a static web page—I saw the foundation of a fully automated, production-grade system. The goal wasn't just to showcase my work, but to use this as an opportunity to demonstrate the same performance-driven, cost-efficient, and DevOps-optimized approach I offer to clients.\n" +
      "\n" +
      "The original project came as a typical monolith of `npm` packages, bloated build artifacts, and minimal scalability. My first move was surgical: I replaced `npm` with `yarn` and committed a strict `yarn.lock` file. This single change reduced installation times dramatically, providing faster dependency resolution and deterministic builds that saved time every CI/CD run. Speaking of which—I integrated a GitLab CI pipeline to handle the entire image lifecycle. From build to pushing to GitLab Container Registry, every push to `master` triggered a clean and repeatable deployment. Zero human error, full automation.\n" +
      "\n" +
      "Next came optimization. The initial Docker image was around 300MB—way too much for a portfolio site. So I rewrote the Dockerfile using a multi-stage build approach: build the static assets with `node:alpine`, and serve them with the blazing-fast `nginx:alpine`. Final image size? Just 50MB. Startup time dropped, memory usage plummeted, and the container was now cloud-friendly.\n" +
      "\n" +
      "But I didn’t stop there. I needed this site to be accessible to both German and English-speaking clients. One option was to spin up two containers, one per language. Fast, yes—but bloated, and harder to maintain. Instead, I went with a React-native approach: inject language context into state, re-render all text accordingly, and avoid a second deployment altogether. This decision reduced server footprint, simplified orchestration, and aligned with modern frontend engineering best practices.\n" +
      "\n" +
      "With the site live, I turned my attention to infrastructure observability. How could I be confident it was running smoothly on my minimal €4/month VPS? That’s when I brought in Prometheus and Grafana. Instead of deploying them manually, I wrote an Ansible playbook to provision both monitoring tools as containers—declaratively, predictably, and reproducibly. But what about access?\n" +
      "\n" +
      "I added a secure reverse proxy with NGINX to route traffic to different services. `camilo-fernandez.com` served the portfolio, while `monitoring.camilo-fernandez.com` brought up Grafana. One NGINX instance, two domains, fully SSL-secured. Rewriting the NGINX config to handle both services behind HTTPS was a major infrastructure shift—but I handled the transition confidently thanks to Ansible. Every change, every volume mount, every exposed port—tracked and redeployed with a single playbook.\n" +
      "\n" +
      "To support this dual-domain setup, I needed new SSL certificates. I used Certbot and wrote an automated playbook to handle webroot challenges, DNS propagation, and certificate renewal. When the automation hit a wall (due to the challenge validation needing a live NGINX server), I adapted by crafting a helper Bash script. It took only a few seconds to run manually and gave me back full automation after a single manual bootstrap.\n" +
      "\n" +
      "Node Exporter came next, exposing server metrics like CPU usage, memory load, and disk IO. I configured Grafana to auto-import a custom dashboard so I could get instant feedback on server performance from any browser. Again, all with Ansible.\n" +
      "\n" +
      "💸 Cost Breakdown:\n" +
      "\n" +
      "- VPS: €4/month\n" +
      "- Domain + SSL: €3/month\n" +
      "- Total: **€7/month for full observability, automation, and production-grade hosting**\n" +
      "\n" +
      "Setting this up in Azure would mean provisioning:\n" +
      "\n" +
      "- App Service Plan\n" +
      "- Application Gateway with SSL termination\n" +
      "- Azure Monitor or Log Analytics for metrics\n" +
      "\n" +
      "All in, even conservative estimates would start around **€40–60/month**—nearly 10x the cost.\n" +
      "\n" +
      "This project is more than a portfolio. It’s a proof-of-concept of what modern infrastructure should be: fast, secure, automated, and scalable. I didn’t just deploy a website. I built a DevOps pipeline, engineered high-performance infrastructure, and turned a template into a teaching tool.\n" +
      "\n" +
      "If I can do this for my portfolio, imagine what I could do for your business.\n" +
      "\n",
    //image: "images/blog/devops-blog-cover.png",
    date: "April 2, 2025"
  }
];

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayBlogCard: "true",
  blogs: [
    {
      url: "/blogs",
      title: "From Template to Infrastructure: My Portfolio Journey.",
      description:
        "My record of my first public Blog documenting my train thought for creating this website"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  en: {
    title: "Resume",
    subtitle: "Feel free to download my resume"
  },
  de: {
    title: "Lebenslauf",
    subtitle: "Lade gerne meinen Lebenslauf herunter"
  },
  display: false // Set to true to show this section
};

const contactInfo = {
  en: {
    title: emoji("Contact Me ☎️"),
    subtitle:
      "Discuss a project or just want to say hi? My inbox is open for all."
  },
  de: {
    title: emoji("Kontakt ☎️"),
    subtitle:
      "Du willst über ein Projekt sprechen oder einfach Hallo sagen? Meine Inbox ist offen."
  },
  number: "+49 1515 618 7052",
  email_address: "fernandez.camilo@live.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  menu,
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogPosts,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
